import React from 'react';

const MyAccount = ({ iconClass }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke='currentColor' strokeWidth={1} width='1em' height='1em' viewBox="-1 -1 46.43 46.43" className={iconClass}><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M22.21,0A22.22,22.22,0,1,0,44.43,22.21,22.23,22.23,0,0,0,22.21,0Zm0,1A21.17,21.17,0,0,1,39,35.19,22.18,22.18,0,0,0,25.8,27.86a9.52,9.52,0,1,0-7.18,0A22.18,22.18,0,0,0,5.47,35.19,21.18,21.18,0,0,1,22.21,1Zm0,26.57a8.52,8.52,0,1,1,8.52-8.52A8.53,8.53,0,0,1,22.21,27.57Zm0,15.86A21.14,21.14,0,0,1,6.11,36a21.21,21.21,0,0,1,32.21,0A21.18,21.18,0,0,1,22.21,43.43Z" /></g></g></svg>
    );
}

export default MyAccount;